import { render, staticRenderFns } from "./BatchProductionLogDetails.vue?vue&type=template&id=3ed16c72&scoped=true"
import script from "./BatchProductionLogDetails.vue?vue&type=script&lang=js"
export * from "./BatchProductionLogDetails.vue?vue&type=script&lang=js"
import style0 from "./BatchProductionLogDetails.vue?vue&type=style&index=0&id=3ed16c72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed16c72",
  null
  
)

export default component.exports